export const PAYER_TYPE = 'Payer Type';
export const PAYER_TYPES = `${PAYER_TYPE}s`;
export const SCROLL_TOP_OFFSET = 50;

export const subTitleDdaSettings =
  "These settings control default DDA settings for internal transfers when we don't receive them from the client.";
export const titleDdaSettings = 'Internal Transfer Default DDA Permissions';

const getButtonDisabled = (formikContext) => {
  const { dirty, isSubmitting } = formikContext;

  return isSubmitting || !dirty;
};

export const getValue = (formikContext) => {
  const {
    dirty,
    handleSubmit,
    isValid,
    isSubmitting,
    resetForm,
    setSubmitting,
    values,
  } = formikContext;

  return {
    dirty,
    disabled: getButtonDisabled(formikContext),
    handleSubmit,
    isValid,
    isSubmitting,
    resetForm,
    setSubmitting,
    values,
  };
};
